import type { ButtonProps } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'

import { useSendContractContext } from './SendContractModal'

export const SendContractEmailButton = (props: ButtonProps) => {
  const { onOpen } = useSendContractContext()
  return <Button
    onClick={onOpen}
    variant="outline"
    type="button"
    mt={3}
    {...props}
  >
    Odeslat e-mail klientovi
  </Button>
}